export class LoginCheckPatientRequest {
    public birthDate: Date;
    public CPF: string;
    public motherName: string;
}